export default __webpack_public_path__ + "static/media/olivier.b2908b40.jpg";